import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarMenuItemComponent } from '@app/shared/components/sidebar/sidebar-menu-item/sidebar-menu-item.component';
import { SidebarComponent } from '@app/shared/components/sidebar/sidebar.component';

@Component({
  selector: 'app-operations-layout',
  standalone: true,
  imports: [RouterOutlet, SidebarComponent, SidebarMenuItemComponent],
  templateUrl: './operations-layout.component.html',
  host: { class: 'd-flex flex-fill' }
})
export class OperationsLayoutComponent {}
